module.exports = __webpack_public_path__ + "static/img/birthday.d10a8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/birthday.png
// module id = SAzx
// module chunks = 1